module.exports = {
  generateHeaderMenuLinks(arr) {
    return arr.map((link) => `<a href="${link.href}">${link.label}</a>`).join('');
  },

  async checkElement(selector) {
    // while the element is not present in the DOM, when it is and rings true, we are ready to apply opacity/blur
    while (document.querySelector(selector) === null) {
       await new Promise((resolve) => requestAnimationFrame(resolve));
    }
 
    return document.querySelector(selector);
 },
};



// WEBPACK FOOTER //
// ./scriptPartials/helperFunctions.js